import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  baseStyle: {
    fontFamily: 'MAN-light, Arial, sans-serif',
    fontSize: theme.typography.pxToRem(15),
    fontWeight: '300',
    color: '#303a44',
    lineHeight: 1.4
  },
  extraLineHeightStyle: {
    lineHeight: 1.6
  },
  condensedStyle: {
    fontFamily: 'MANEurope, Arial, sans-serif',
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'normal',
    color: '#303c49',
    lineHeight: 1.4
  },
  largeStyle: {
    fontSize: theme.typography.pxToRem(18),
    lineHeight: 1.33
  }
})

const Paragraph = ({
  classes: { baseStyle, condensedStyle, extraLineHeightStyle, largeStyle },
  className,
  component,
  condensed,
  extraLineHeight,
  large,
  children,
  ...otherProps
}) => {
  const paragraphClass = classNames(
    condensed ? condensedStyle : baseStyle,
    extraLineHeight ? extraLineHeightStyle : '',
    large ? largeStyle : '',
    className
  )
  return (
    <Typography
      component={component || 'p'}
      className={paragraphClass}
      {...otherProps}
    >
      {children}
    </Typography>
  )
}

Paragraph.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array
  ]),
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  condensed: PropTypes.bool,
  extraLineHeight: PropTypes.bool,
  large: PropTypes.bool,
  children: PropTypes.node
}

export default withStyles(styles)(Paragraph)



// WEBPACK FOOTER //
// ./src/styleguide/Paragraph.js